<template>
  <v-dialog v-model="dialog" max-width="700px">
    <template v-slot:activator="{ on }">
      <v-btn :color="$primary" dark class="mb-2" v-on="on">{{ModalNewText}}</v-btn>
    </template>
    <v-card>
      <v-card-title>
        <span class="headline">{{ DialogTitle }}</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-form ref="form" :lazy-validation="true">
            <v-row>
              <UserExists
                v-if="Store=='donativo' && MyIndex==-1"
                :MyObject="MyObject"
                :FormFields="FormFields"
                :Store="Store"
              />

              <v-col
                v-for="(item, idx) in FormFields"
                :key="idx"
                :cols="item.size.cols"
                :sm="item.size.sm"
                :md="item.size.md"
              >
                <label v-if="typeof item.label != 'undefined'" class="label-modal">{{item.label}}</label>

                <v-subheader v-if="item.type == 'subheader'">{{item.title}}</v-subheader>

                <v-text-field
                  autocomplete="off"
                  v-if="item.type == 'text'"
                  v-model="MyObject[item.name]"
                  :rules="item.rules"
                  :color="$primary"
                  :disabled="CheckIsDisabled()"
                ></v-text-field>

                <v-textarea
                  autocomplete="off"
                  v-if="item.type == 'textarea'"
                  v-model="MyObject[item.name]"
                  :rows="item.rows"
                  :auto-grow="true"
                  :rules="item.rules"
                  :color="$primary"
                ></v-textarea>

                <v-autocomplete
                  autocomplete="off"
                  v-if="item.type == 'array'"
                  :items="AutoCompleteValues(item.store)"
                  :disabled="$_ISDISABLED(item.disabled, getSession.user.id_tipo_utilizador) || CheckIsDisabled()"
                  :color="$primary"
                  v-model="MyObject[item.name]"
                  :rules="item.rules"
                  item-text="nome"
                  :item-value="item.name"
                ></v-autocomplete>

                <DCL v-if="item.type == 'dcl'" :MyObject="MyObject" :dialog="dialog" />

                <DeuSangue
                  v-if="item.type == 'deusangue'"
                  :MyObject="MyObject"
                  :RULES="item.rules"
                />

                <PASSWORD v-if="item.type == 'password' && MyIndex==-1" :MyObject="MyObject" />

                <DATA
                  v-if="item.type == 'data'"
                  :MyObject="MyObject"
                  :Field="item.name"
                  :Title="item.title"
                  :RULES="item.rules"
                />

                <SINSTITUICOES
                  v-if="item.type == 'instituicoes'"
                  :Multiple="typeof item.multiple != 'undefined' && item.multiple"
                  :Disabled="item.disabled"
                  :All="item.all"
                  :MyObject="MyObject"
                  :RULES="item.rules"
                />
              </v-col>

              <AssociadoCotas
                v-if="Store=='associado' && MyIndex>-1"
                :MyObject="MyObject"
                :Store="Store"
              />
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions v-if="Store == 'utilizador_colheita'">
        <v-spacer></v-spacer>
        <v-btn :color="$primary" text @click="dialog=false">Cancelar</v-btn>
        <v-btn :color="$primary" text @click="SaveUtilizadorColheita">Guardar</v-btn>
      </v-card-actions>
      <v-card-actions v-else>
        <v-spacer></v-spacer>
        <v-btn :color="$primary" text @click="close">Cancelar</v-btn>
        <v-btn :color="$primary" text @click="save">Guardar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import CRUD from "@/mixins/_CRUD"
import UC from "@/mixins/_UC"
export default {
  components: {
    DCL: () => import("@/components/selects/DCL"),
    SINSTITUICOES: () => import("@/components/selects/Instituicoes"),
    PASSWORD: () => import("@/components/inputs/password"),
    DATA: () => import("@/components/inputs/Data"),
    AssociadoCotas: () => import("@/components/AssociadoCotas"),
    DeuSangue: () => import("@/components/selects/DeuSangue"),
    UserExists: () => import("@/components/selects/UserExists")
  },
  mixins: [CRUD, UC],
  props: {
    FormFields: Array,
    DialogTitle: String,
    ModalNewText: String,
    MyObject: Object,
    MyIndex: Number,
    Store: String
  },
  computed: {
    getSession() {
      return this.$store.getters["session/getState"]
    }
  },
  data: () => ({
    dialog: false
  }),
  watch: {
    dialog(val) {
      if (!val && this.Store == "utilizador_colheita") {
        this.$refs.form.reset()
        return
      }

      val || this.close()

      if (
        val &&
        this.FormFields.findIndex(el => {
          return typeof el.type != "undefined" && el.type == "instituicoes"
        }) > -1 &&
        this.Store == "utilizador"
      ) {
        this.MyObject.instituicoes = []
        this.MyObject.instituicoes[0] = this.getSession.instituicao
      }

      if (
        val &&
        (this.Store == "brigada" ||
          this.Store == "pedido_galardao" ||
          this.Store == "associado" ||
          this.Store == "donativo")
      )
        this.MyObject.id_instituicao = this.getSession.instituicao

      this.$forceUpdate()
    }
  },
  mounted() {},
  created() {
    this.$eventBus.$on("AddDialog", state => {
      this.dialog = state
    })

    this.$eventBus.$on("ResetForm", () => {
      this.ResetForm()
    })

    this.$eventBus.$on("SetMyObjectValues", data => {
      this.SetMyObjectValues(data)
    })
  },
  methods: {
    close() {
      this.dialog = false

      setTimeout(() => {
        this.$eventBus.$emit("ClearDialog")
        this.$refs.form.reset()
      }, 110)
    },

    ResetForm() {
      this.$refs.form.reset()
      this.$forceUpdate()
    },

    SetMyObjectValues(data) {
      for (const key of Object.keys(data)) {
        this.MyObject[key] = data[key]
      }

      this.$forceUpdate()
    },

    AutoCompleteValues(store) {
      if (this.Store == "utilizador_colheita" && store == "utilizador")
        return this.$store.getters[store + "/getAll"].map(el => {
          el.disabled =
            this.$store.getters["utilizador_colheita/getAll"].findIndex(e => {
              return e.id_utilizador == el.id_utilizador
            }) > -1
          return el
        })
      else
        return this.$store.getters[store + "/getAll"].map(el => {
          el.disabled = false
          return el
        })
    },

    CheckIsDisabled() {
      return this.MyIndex > -1 && this.Store == "associado"
    }
  }
}
</script>
